module.exports = __webpack_public_path__ + "static/media/wistia.b4b0ba1b.png";